<template>
    <div>
        <ol>
            <li class="text text-margin">{{ $t('faq.kodi.step5.text1') }}</li>
            <li class="text text-margin">{{ $t('faq.kodi.step5.text2') }}</li>
            <li class="text text-margin">{{ $t('faq.kodi.step5.text3') }}</li>
            <li class="text">{{ $t('faq.kodi.step5.text4') }}</li>
            <p class="text text-margin">{{ $t('faq.kodi.step5.onceYoureDone') }}</p>
            <p class="text text-margin">{{ $t('faq.kodi.step5.hereIsTheGuide') }}</p>
        </ol>
        <ol>
            <li v-for="i in 24" :key="i" class="text text-margin">{{ $t(`faq.kodi.step5.text${i + 4}`) }}</li>
        </ol>
    </div>
</template>
<script>
export default {
}
</script>
<style scoped>
@import "../../../components/styles/guides-default-styles.css";
</style>
